import { jsx as _jsx } from "react/jsx-runtime";
import { CardActionArea } from "@mui/material";
import { forwardRef } from "react";
export const UiCardActionArea = forwardRef((props, ref) => _jsx(CardActionArea, Object.assign({ ref: ref }, props)));
//# sourceMappingURL=ui_card_action_area.js.map